import {
    useCallback,
    useEffect,
    useState
} from 'react';
import { useSelector } from 'react-redux';

import { KEY_STATE_HISTORY } from '../screens/Services/Backup/common/backupData';
import { getFormValues } from '../selectors/forms';
import { dbGettr } from '../selectors/utils';

export const useIsLastBackupsFailed = () => {
    const formValues = useSelector(getFormValues);
    const backupStateHistoryLength = useSelector(dbGettr('backupStateHistoryLength', 5));

    const getIsBackupsFailed = useCallback(() => {
        let backupHistory = formValues?.[KEY_STATE_HISTORY] || [];
        if (backupHistory.length < backupStateHistoryLength) {
            backupHistory = [
                ...backupHistory,
                ...Array(backupStateHistoryLength - backupHistory.length)
                    .fill({ state: 'success' }),
            ];
        } else {
            backupHistory = backupHistory.slice(0, backupStateHistoryLength);
        }
        return !!(
            Array.isArray(backupHistory) &&
            backupHistory.every(({ state }) => state === 'error') &&
            backupHistory.length > 0
        );
    }, [ formValues, backupStateHistoryLength ]);

    const [ isBackupsFailed, setIsBackupsFailed ] = useState(getIsBackupsFailed());

    useEffect(() => {
        setIsBackupsFailed(getIsBackupsFailed());
    }, [ formValues, getIsBackupsFailed ]);

    return isBackupsFailed;
};

export const useIsLastBackupFailed = () => {
    const formValues = useSelector(getFormValues);

    const getIsBackupsFailed = useCallback(() => {
        const backupHistory = formValues?.[KEY_STATE_HISTORY];
        return !!(Array.isArray(backupHistory) && backupHistory?.length > 0 && backupHistory?.[0].state === 'error');
    }, [ formValues ]);

    const [ isBackupsFailed, setIsBackupsFailed ] = useState(getIsBackupsFailed());

    useEffect(() => {
        setIsBackupsFailed(getIsBackupsFailed());
    }, [ formValues, getIsBackupsFailed ]);

    return isBackupsFailed;
};

export const useLastBackupState = () => {
    const formValues = useSelector(getFormValues);

    const getLastBackupState = useCallback(() => {
        return formValues?.[KEY_STATE_HISTORY]?.[0] || {};
    }, [ formValues ]);

    const [ lastBackupState, setLastBackupState ] = useState(getLastBackupState());

    useEffect(() => {
        setLastBackupState(getLastBackupState());
    }, [ formValues, getLastBackupState ]);

    return lastBackupState;
};
